import React from "react";
import injectSheet from "react-jss";

const Row = (props) => {
  const { classes, children } = props;

  return (
    <div
      className={`${classes.rowContainer}${
        classes["0"] ? ` ${classes["0"]}` : ""
      }`}
    >
      {children}
    </div>
  );
};

const styles = () => ({
  rowContainer: {
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
  },
});

export default injectSheet(styles)(Row);



// WEBPACK FOOTER //
// ./src/modules/core/components/row.jsx